import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import spTranslation from "./spTranslation.json";
import enTranslation from "./enTranslation.json";

const resources = {
  en: {
    translation: {
      ...enTranslation.en,
    },
  },
  sp: {
    translation: {
      ...spTranslation.sp,
    },
  },
};

// Initialize i18next
i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
